import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import * as defaultRoutes from "@/utils/routes";
import type RouteBase from "@/utils/routes/RouteBase";

type RouteMap = Record<string, RouteBase>;

export const useActiveRoute = (routes: RouteMap = defaultRoutes) => {
  const { pathname, asPath } = useRouter();
  const [activeRoute, setActiveRoute] = useState<RouteBase | undefined>(
    Object.values(routes).find((item) => item.fullPath === pathname)
  );

  useEffect(() => {
    Object.keys(routes).forEach((item) => {
      if (routes[item].fullPath === pathname || routes[item].fullPath === asPath) {
        setActiveRoute(routes[item]);
      }
    });
  }, [asPath, pathname]);

  return { activeRoute };
};
